import { MuiAutocomplete } from "./components/MuiAutocomplete"
import { MuiDataGrid } from "./components/MuiDataGrid"
import { MuiFormControl } from "./components/MuiFormControl"
import { MuiFormLabel } from "./components/MuiFormLabel"
import { MuiInputBase } from "./components/MuiInputBase"
import { MuiInputLabel } from "./components/MuiInputLabel"
import { MuiListItemText } from "./components/MuiListItemText"
import { MuiOutlinedInput } from "./components/MuiOutlinedInput"
import { MuiSvgIcon } from "./components/MuiSvgIcon"
import { MuiTextField } from "./components/MuiTextField"
import { Tabs } from "./components/Tabs"

export const components = {
  MuiAutocomplete,
  MuiDataGrid,
  MuiFormControl,
  MuiFormLabel,
  MuiInputBase,
  MuiInputLabel,
  MuiListItemText,
  MuiOutlinedInput,
  MuiSvgIcon,
  MuiTextField,
  Tabs,
}
